/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

if (require("targetenv").isBrowser) {
    require("leaflet"); // creates global.L
    require("mapbox.js"); // attaches to global.L
    require("leaflet-fullscreen"); // attaches to L.Control.Fullscreen
    require("leaflet-minimap"); // attaches to L.Control.MiniMap
    require("leaflet.markercluster/dist/leaflet.markercluster-src.js"); // attaches to L.MarkerClusterGroup
    require("leaflet-draw");
    require("leaflet-dialog");
    module.exports = global.L;
} else {
    module.exports = {
        mapbox: {
            map: function mapShim() {
                throw new Error("Mapbox may only be used in a browser environment.");
            }
        }
    };
}




//////////////////
// WEBPACK FOOTER
// ./~/mapping/mapbox.js
// module id = 581
// module chunks = 49